import React, { useState, useEffect } from "react";
import Logo from "../../../assets/image/logo-image.png";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { storage } from "../../../utils/auth";
import { Spinner } from "react-bootstrap";

function SuperAdminAreaLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [update, setUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginBackground, setLoginBackground] = useState("");
  const [loginBackgroundColor, setLoginBackgroundColor] = useState("");
  const [brandingLogo, setBrandingLogo] = useState("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleChange();
    }
  };

  useEffect(() => {
    if (storage.get("token", "superadmin")) {
      navigate(`/superadmin/dashboard`);
    }
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        if (res.data.data) {
          if (res.data.data.login_background) { setLoginBackground(res.data.data.login_background); }
          if (res.data.data.login_background_color) { setLoginBackgroundColor(res.data.data.login_background_color); }
          if (res.data.data.branding_logo) {
            setBrandingLogo(res.data.data.branding_logo);
          }
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const loginBGStyle = loginBackground
    ? {
      backgroundImage: `url("${process.env.REACT_APP_IMAGE_URL}/branding/${loginBackground}")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
      backgroundColor: loginBackgroundColor || "#ee272a",
    }
    : {};

  const logoSrc = brandingLogo
    ? `${process.env.REACT_APP_IMAGE_URL}/branding/${brandingLogo}`
    : Logo;

  const handleChange = () => {
    setIsLoading(true);
    if (!email) {
      message.error("Enter username or email");
      setIsLoading(false);
      return;
    }
    if (!password) {
      message.error("Enter password");
      setIsLoading(false);
      return;
    }

    const requiredRole = window.location.pathname.startsWith("/subadmin") ? "subadmin" : "superadmin";
    
    axios
      .post(`${process.env.REACT_APP_API_END_POINT}/login`, { email, password, requiredRole })
      .then((response) => {
        if (response.data.message === "Login Successfully") {
          const role = response.data.role;
          const namespace = (role === "subadmin") ? "subadmin" : "superadmin";

          // Insert token and category in local storage
          storage.set("token", response.data.token, namespace);
          storage.set("user_id", response.data.category._id, namespace);
          storage.set("type_of_user", "/superadmin/login", namespace);

          if (role === "subadmin") {
            storage.set("subAdminPermissions", JSON.stringify(response.data.permissions), "subadmin");
            storage.set("permission", JSON.stringify(["subadmin"]), "subadmin"); // For MainRoute filtering
            message.success("Login Successfully");
            navigate("/subadmin/dashboard");
          } else {
            storage.set("permission", JSON.stringify(response.data.category.permissions), "superadmin");
            storage.set("role", role, "superadmin");

            message.success("Login Successfully");
            navigate("/superadmin/dashboard");
          }
        } else {
          message.error(response.data.message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        message.error("Login Failed");
      });
  };

  return (
    <>
      <div
        className="kcebg"
        style={loginBGStyle}
      >
        <div className="exhibitorlogin">
          <div className="exhibitorloginbody">
            <Form className="my-4" onSubmit={(e) => e.preventDefault()}>
              <Form.Control
                type="username"
                placeholder="Username"
                className="my-4"
                onChange={(e) => setEmail(e.target.value)}
                required
                onKeyDown={handleKeyDown}
              />
              <Form.Control
                type="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                required
                onKeyDown={handleKeyDown}
              />
              <Button className="my-4 btn-block" onClick={handleChange}>
                {isLoading ? <Spinner animation="border" size="sm" /> : "Login"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default SuperAdminAreaLogin;
